import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

import { getAuthUser } from '../../../helpers'
import { Loading, TooltipWrapper } from '../../common'
import { SupplierBrand } from '../../../models'
import { getSupplierBrand } from '../../../api'
import { EditSupplierBrandForm } from './edit'
import { SupplierBrandTable } from './resourceTable'
import defineAbilityFor from './defineAbility'
import { InsufficientPermissions } from '../../common'
import { useNavigate } from 'react-router-dom'
import { DeleteSupplierBrand } from './delete'

export const SupplierBrandCard = () => {
    const [supplierBrand, setSupplierBrand] = useState<SupplierBrand>()
    const [isEditing, setIsEditing] = useState(false)
    const [isDeleting, setIsDeleting] = useState(false)

    const params = useParams()
    const ability = defineAbilityFor(getAuthUser())
    const navigate = useNavigate()

    useEffect(() => {
        if (params.supplierBrandId && ability.can('View', 'SupplierBrand')) {
            getSupplierBrand(params.supplierBrandId).then((response) => {
                if (response.status === 200) {
                    setSupplierBrand(new SupplierBrand(response.data))
                }
            })
        }
    }, [params.supplierBrandId])

    if (!ability.can('View', 'SupplierBrand')) {
        return <InsufficientPermissions />
    }

    if (!(supplierBrand instanceof SupplierBrand)) {
        return <Loading />
    }
    if (isDeleting) {
        return (
            <DeleteSupplierBrand supplierBrand={supplierBrand} setIsDeleting={setIsDeleting} />
        )
    }

    return (
        <div className="container card col-xs-12 col-xl-6">
            <div className="card-body col-xs-12 row d-flex flex-row justify-content-between mb-5">
                <div className="row flex-row mb-5">
                    <h3 className="ps-0 d-inline-flex card-title w-50">
                        {supplierBrand.name}
                    </h3>
                    <div className="pe-0 d-inline-flex justify-content-end w-50 gap-2">
                        <TooltipWrapper
                            condition={!ability.can('Edit', 'SupplierBrand')}
                            element={
                                <button
                                    className="btn btn-primary"
                                    disabled={!ability.can('Edit', 'SupplierBrand')}
                                    onClick={() => setIsEditing(!isEditing)}
                                >
                                    Toggle Edit
                                </button>
                            }
                            message="Executive permission required to edit supplierBrand"
                        />
                        <TooltipWrapper
                            condition={!ability.can('Delete', 'SupplierBrand')}
                            element={
                                <button
                                    className="btn btn-danger"
                                    disabled={!ability.can('Delete', 'SupplierBrand')}
                                    onClick={() => setIsDeleting(true)}
                                >
                                    Delete
                                </button>
                            }
                            message="SR Lead permission required to delete supplier brand"
                        />
                    </div>
                </div>
                {!isEditing && <SupplierBrandTable supplierBrand={supplierBrand} />}
                {isEditing && (
                    <EditSupplierBrandForm
                        supplierBrand={supplierBrand}
                        setIsEditing={setIsEditing}
                        setSupplierBrand={setSupplierBrand}
                    />
                )}
                <div className="ps-0 d-inline-flex w-50">
                    <button
                        onClick={() => navigate(`/suppliers/brands`)}
                        className="btn btn-primary mb-3 w-fit"
                    >
                        Back to Brands
                    </button>
                </div>
            </div>
        </div>
    )
}
